"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateFilter = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var isEqual_1 = tslib_1.__importDefault(require("lodash/isEqual"));
var isNil_1 = tslib_1.__importDefault(require("lodash/isNil"));
var noop_1 = tslib_1.__importDefault(require("lodash/noop"));
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var PeriodExclusion_1 = require("./utils/PeriodExclusion");
var DateFilterCore_1 = require("./DateFilterCore");
var OptionValidation_1 = require("./validation/OptionValidation");
var interfaces_1 = require("./interfaces");
var Platform_1 = require("./constants/Platform");
var FilterOptionNormalization_1 = require("./utils/FilterOptionNormalization");
/**
 * {@link https://sdk.gooddata.com/gooddata-ui/docs/date_filter_component.html | DateFilter} is a component for configuring a date filter value.
 *
 * @public
 */
var DateFilter = /** @class */ (function (_super) {
    tslib_1.__extends(DateFilter, _super);
    function DateFilter(props) {
        var _this = _super.call(this, props) || this;
        _this.handleApplyClick = function () {
            var normalizedSelectedFilterOption = FilterOptionNormalization_1.normalizeSelectedFilterOption(_this.state.selectedFilterOption);
            _this.props.onApply(normalizedSelectedFilterOption, _this.state.excludeCurrentPeriod);
        };
        _this.onChangesDiscarded = function () {
            _this.setState(function () { return DateFilter.getStateFromProps(_this.props); });
        };
        _this.onCancelClicked = function () {
            _this.props.onCancel();
            _this.onChangesDiscarded();
        };
        _this.onDropdownOpenChanged = function (isOpen) {
            if (isOpen) {
                _this.props.onOpen();
            }
            else {
                _this.props.onClose();
                _this.onChangesDiscarded();
            }
        };
        _this.handleExcludeCurrentPeriodChange = function (excludeCurrentPeriod) {
            _this.setState({ excludeCurrentPeriod: excludeCurrentPeriod });
        };
        _this.handleSelectedFilterOptionChange = function (selectedFilterOption) {
            _this.setState(function (state) {
                return DateFilter.getStateFromSelectedOption(selectedFilterOption, state.excludeCurrentPeriod);
            });
        };
        _this.state = DateFilter.getStateFromProps(props);
        return _this;
    }
    DateFilter.getDerivedStateFromProps = function (nextProps, prevState) {
        if (!isEqual_1.default(nextProps.selectedFilterOption, prevState.initSelectedFilterOption) ||
            nextProps.excludeCurrentPeriod !== prevState.initExcludeCurrentPeriod) {
            return DateFilter.getStateFromProps(nextProps);
        }
        return null;
    };
    DateFilter.getStateFromProps = function (props) {
        var canExcludeCurrent = PeriodExclusion_1.canExcludeCurrentPeriod(props.selectedFilterOption);
        return {
            initSelectedFilterOption: props.selectedFilterOption,
            selectedFilterOption: props.selectedFilterOption,
            initExcludeCurrentPeriod: props.excludeCurrentPeriod,
            excludeCurrentPeriod: canExcludeCurrent ? props.excludeCurrentPeriod : false,
            isExcludeCurrentPeriodEnabled: canExcludeCurrent,
        };
    };
    DateFilter.prototype.componentDidMount = function () {
        DateFilter.checkInitialFilterOption(this.props.selectedFilterOption);
    };
    DateFilter.prototype.render = function () {
        var _a = this.props, customFilterName = _a.customFilterName, dateFilterMode = _a.dateFilterMode, dateFormat = _a.dateFormat, filterOptions = _a.filterOptions, originalSelectedFilterOption = _a.selectedFilterOption, originalExcludeCurrentPeriod = _a.excludeCurrentPeriod, availableGranularities = _a.availableGranularities, isEditMode = _a.isEditMode, locale = _a.locale;
        var _b = this.state, excludeCurrentPeriod = _b.excludeCurrentPeriod, selectedFilterOption = _b.selectedFilterOption, isExcludeCurrentPeriodEnabled = _b.isExcludeCurrentPeriodEnabled;
        return dateFilterMode === "hidden" ? null : (react_1.default.createElement(DateFilterCore_1.DateFilterCore, { availableGranularities: availableGranularities, customFilterName: customFilterName, dateFormat: dateFormat, disabled: dateFilterMode === "readonly", excludeCurrentPeriod: excludeCurrentPeriod, originalExcludeCurrentPeriod: originalExcludeCurrentPeriod, isExcludeCurrentPeriodEnabled: isExcludeCurrentPeriodEnabled, isEditMode: isEditMode, filterOptions: filterOptions, selectedFilterOption: selectedFilterOption, originalSelectedFilterOption: originalSelectedFilterOption, locale: locale, onApplyClick: this.handleApplyClick, onCancelClick: this.onCancelClicked, onDropdownOpenChanged: this.onDropdownOpenChanged, onExcludeCurrentPeriodChange: this.handleExcludeCurrentPeriodChange, onSelectedFilterOptionChange: this.handleSelectedFilterOptionChange, errors: OptionValidation_1.validateFilterOption(selectedFilterOption) }));
    };
    DateFilter.defaultProps = {
        dateFormat: Platform_1.DEFAULT_DATE_FORMAT,
        isEditMode: false,
        locale: "en-US",
        onCancel: noop_1.default,
        onOpen: noop_1.default,
        onClose: noop_1.default,
    };
    DateFilter.getStateFromSelectedOption = function (selectedFilterOption, excludeCurrentPeriod) {
        var canExcludeCurrent = PeriodExclusion_1.canExcludeCurrentPeriod(selectedFilterOption);
        return {
            selectedFilterOption: selectedFilterOption,
            excludeCurrentPeriod: canExcludeCurrent ? excludeCurrentPeriod : false,
            isExcludeCurrentPeriodEnabled: canExcludeCurrent,
        };
    };
    DateFilter.checkInitialFilterOption = function (filterOption) {
        if (sdk_backend_spi_1.isAbsoluteDateFilterForm(filterOption) && (isNil_1.default(filterOption.from) || isNil_1.default(filterOption.to))) {
            // eslint-disable-next-line no-console
            console.warn("The default filter option is not valid. Values 'from' and 'to' from absoluteForm filter option must be specified.");
        }
        if (interfaces_1.isUiRelativeDateFilterForm(filterOption) &&
            (isNil_1.default(filterOption.from) || isNil_1.default(filterOption.to))) {
            // eslint-disable-next-line no-console
            console.warn("The default filter option is not valid. Values 'from' and 'to' from relativeForm filter option must be specified.");
        }
    };
    return DateFilter;
}(react_1.default.PureComponent));
exports.DateFilter = DateFilter;
//# sourceMappingURL=DateFilter.js.map